import {
  color,
  hexToRGBa,
} from './colors';

import {
  fontsize,
  radiussize,
  spacingsize,
} from './sizing';

import {
  azoSansRegular,
  azoSansBlack,
  azoSansBold,
  azoSansLight,
  azoSansMedium,
  brandonGrotesqueRegular,
  brandonGrotesqueBold,
  brandonGrotesqueLight,
  brandonGrotesqueMedium,
  garamondRegular,
  garamondSemibold,
  garamondRegularItalic,
  garamondSemiboldItalic,
  elaineRegular,
  robotoLight,
} from './fonts.css';

import {
  tiny,
  mobile,
  mobileUp,
  mobileDown,
  tabletPortrait,
  tabletPortraitUp,
  tabletPortraitDown,
  tabletLandscape,
  tabletLandscapeUp,
  tabletLandscapeDown,
  desktop,
  desktopUp,
  desktopDown,
  max,
} from './mediaqueries';

import {
  buttonShadowDefault,
  textShadowDefault,
} from './shadows';

import {
  fieldTransition,
  fieldInputTransition,
} from './transitions';

export const settings = {
  colors: {
    color,
    hexToRGBa,
  },
  fonts: {
    azoSansRegular,
    azoSansBlack,
    azoSansBold,
    azoSansLight,
    azoSansMedium,
    brandonGrotesqueRegular,
    brandonGrotesqueBold,
    brandonGrotesqueLight,
    brandonGrotesqueMedium,
    garamondRegular,
    garamondSemibold,
    garamondRegularItalic,
    garamondSemiboldItalic,
    elaineRegular,
    robotoLight,
  },
  mediaqueries: {
    tiny,
    mobile,
    mobileUp,
    mobileDown,
    tabletPortrait,
    tabletPortraitUp,
    tabletPortraitDown,
    tabletLandscape,
    tabletLandscapeUp,
    tabletLandscapeDown,
    desktop,
    desktopUp,
    desktopDown,
    max,
  },
  sizing: {
    fontsize,
    spacingsize,
    radiussize,
  },
  shadows: {
    buttonShadowDefault,
    textShadowDefault,
  },
  transitions: {
    fieldTransition,
    fieldInputTransition,
  },
};
